import {
  useMutation,
  UseMutationOptions,
  useQueryClient,
} from '@tanstack/react-query'
import {
  permitTemplateEditorKeys,
  RequestTypes,
} from '@core/react-query/features/templates/permitTemplateEditor'
import { permitTemplateKeys } from '@core/react-query/features/templates/permitTemplates/permitTemplate'
import { RequestErrorType } from '@core/utils/api-axios-instance'

export const useActivatePermitTemplateVersion = (
  options?: UseMutationOptions<
    string,
    RequestErrorType,
    RequestTypes['activatePermitTemplateVersion']
  >,
) => {
  const queryClient = useQueryClient()
  return useMutation({
    ...permitTemplateEditorKeys.activateTemplateVersion,
    ...options,
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: permitTemplateKeys._def,
      })
    },
  })
}
